import { createContext, useContext, useEffect, useState } from "react";
import { getContent, LANGS } from "@/data/i18n";

const KEY = "wedding-lang";
const Ctx = createContext(null);

const detect = () => {
  if (typeof window === "undefined") return "ca";
  const saved = window.localStorage.getItem(KEY);
  if (saved && LANGS.some((l) => l.code === saved)) return saved;
  const nav = (navigator.language || "ca").slice(0, 2).toLowerCase();
  if (LANGS.some((l) => l.code === nav)) return nav;
  return "ca";
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState("ca");

  useEffect(() => {
    setLangState(detect());
  }, []);

  useEffect(() => {
    if (typeof document !== "undefined") {
      document.documentElement.lang = lang;
    }
  }, [lang]);

  const setLang = (l) => {
    setLangState(l);
    try {
      window.localStorage.setItem(KEY, l);
    } catch {
      /* noop */
    }
  };

  const content = getContent(lang);
  return (
    <Ctx.Provider value={{ lang, setLang, content, t: content.t, langs: LANGS }}>
      {children}
    </Ctx.Provider>
  );
};

export const useI18n = () => {
  const ctx = useContext(Ctx);
  if (!ctx) throw new Error("useI18n must be used inside LanguageProvider");
  return ctx;
};
